import Swal from "sweetalert2";

export default function sweetAlert(props) {
  const payload = { ...props };
  if (payload.onConfirm) delete payload.onConfirm;
  Swal.fire({
    ...payload,
  }).then((result) => {
    if (props.onConfirm && result.isConfirmed) {
      props.onConfirm();
    }
  });
}
